import { render, staticRenderFns } from "./EditProcess.vue?vue&type=template&id=71fe783c&scoped=true"
import script from "./EditProcess.vue?vue&type=script&lang=js"
export * from "./EditProcess.vue?vue&type=script&lang=js"
import style0 from "./EditProcess.scss?vue&type=style&index=0&id=71fe783c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe783c",
  null
  
)

export default component.exports